<template>
  <ul-dialog
    title="提示"
    width="400px"
    :visible.sync="dialogVisiable">
    <div class="ul-dialog__content">
      <span>{{content}}</span>
    </div>
    <ul-button v-if="isShowConfirm" type="primary" @click="confirm">{{confirmText}}</ul-button>
    <ul-button v-if="isShowCancel" hollow @click="hide">{{cancelText}}</ul-button>
  </ul-dialog>
</template>

<script>
export default {
  name: 'comfirm',
  props: {
    content: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    isShowCancel: {
      type: Boolean,
      default: true
    },
    isShowConfirm: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialogVisiable: true
    }
  },
  methods: {
    hide () {
      this.dialogVisiable = false
      this.onClose()
    },
    confirm () {
      this.hide()
      this.onConfirm()
    }
  }
}
</script>

<style lang="scss" scoped>
.ul-dialog__wrapper{
  ::v-deep{
    .ul-dialog__body {
      padding-bottom: 30px;
    }
  } 
}
.ul-dialog{
  .ul-dialog__content{
    min-height: 72px;
  }
  .ul-button{
    width: 100%;
    margin-top: 16px;
    padding: 14px 20px;
  }
  .ul-button+.ul-button {
      margin-left: 0;
  }
  
}
</style>